<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.banner')"
    :onFetchData="onFetchData"
    resource="banners"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/banners';

@Component
export default class Banners extends Vue {
  @Prop(String) type;

  // change nothing
  // form 新建表单初始化数据（default数据）
  form = {}
  linkTypes = []

  async onFetchData({ type, resource }) {
    if (type === 'index') {
      const { data, pagination } = await this.$request.get(`/${resource}`, { params: { ...this.$route.query } });
      return {
        data,
        pagination
      }
    }

    if (type === 'new' || type === 'edit') {
      const res = await this.$request.get('/page_links/types')
      this.linkTypes = res.map(val => ({ value: val, label: val }));
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/${resource}/${this.$route.params.id}`);

      return { data };
    }

    if (type === 'new') {
      return {}
    }
  }

  async handleTargetUrlLoadPages(node, resolve) {
    const { level, value } = node;
    if (level === 0) {
      resolve(this.linkTypes);
      return;
    }
    if (level === 1) {
      const { data } = await this.$request.get('/page_links', { params: { type: value, page: 0 } });
      resolve(data.map(item => ({ label: Object.keys(item)[0], value: Object.values(item)[0], leaf: true })));
    }
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    const array = [
      'kind_eq',
      'page_position_eq'
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'image',
      {
        key: 'kind',
        minWidth: 135,
      },
      'page_position',
      'position',
      {
        prop: 'target.url',
        label: this.$t('banner.targetUrl'),
      },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { data, type, change }) {
    const array = [
      {
        key: 'image',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 750x320`,
          props: {
            cropper: {
              width: 750,
              height: 320
            }
          }
        }
      },
      {
        key: 'kind',
        renderCell: {
          on: {
            change: (value) => {
              change({ kind: value, target: { url: '' } })
            }
          }
        }
      },
      'page_position',
      {
        key: 'position',
        renderCell: {
          hint: this.$t('hint.positionColumn'),
        },
      },
      data.kind && data.kind === 'mp_link' && {
        prop: 'target_page',
        label: '目标页面',
        renderCell: {
          component: 'el-cascader',
          props: {
            filterable: true,
            clearable: true,
            props: {
              lazy: true,
              emitPath: false,
              lazyLoad: this.handleTargetUrlLoadPages
            }
          },
          on: {
            change: (value) => {
              change({ target: { url: value } })
            }
          }
        }
      },
      data.kind && data.kind !== 'image' && {
        prop: 'target.url',
        label: this.$t('banner.targetUrl'),
        renderCell: {
          required: true,
          component: 'input',
          hint: data.kind === 'mp_link' ? '选择目标页面后自动更新' : '',
          props: {
            disabled: data.kind === 'mp_link',
          }
        }
      }
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'banners.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'banners.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/banners',
    name: 'banners.index',
    component: Banners,
    props: {
      type: 'index',
    }
  },
  {
    path: '/banners/new',
    name: 'banners.new',
    component: Banners,
    props: {
      type: 'new',
    }
  },
  {
    path: '/banners/:id',
    name: 'banners.show',
    component: Banners,
    props: {
      type: 'show',
    }
  },
  {
    path: '/banners/:id/edit',
    name: 'banners.edit',
    component: Banners,
    props: {
      type: 'edit'
    }
  }
]
</script>
